module.exports = __webpack_public_path__ + "static/media/lob-bar.a7fecbe9.png";